import React, { useEffect, useState } from "react";
import TextField from "../../../components/inputs/textfield";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
import { FormValidate } from "../../../components/formValidate";
import { faq_add } from "../admin.api";
import "./view.css";
import TextEditer from "../../../components/inputs/texteditor";
let required = ["question", "answer"];
export default function AddFaq(props) {
  const [formData, setFormData] = useState({
    member: true,
    head: false,
    governing_member: true,
    council_number: false,
  });
  const [snackMessage, setSnackMessage] = useState("");
  const [fileChanged, setFileChanged] = useState(false);
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const handleChange = (e) => {
    let name = e.target?.name;
    let value = e.target?.value;
    let data = formData;
    data = { ...data, [name]: value };
    setFormData(data);
  };

  const handlePhotoFileChange = (e) => {
    setIsActive(true);
    try {
      let flag = false;

      let type = e.target.files[0].name.split(".").pop();

      if (type === "png" || type === "jpeg" || type === "jpg") {
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function (e) {
          var image = new Image();
          image.src = e.target.result;

          image.onload = function () {
            var height = this.height;
            var width = this.width;

            if (height === 400 || width === 400) {
              flag = true;
            }
          };
        };
        setTimeout(() => {
          if (flag) {
            setFileChanged(true);
            setFormData({
              ...formData,
              [e.target.name]: e.target.files[0],
            });
            setIsActive(false);
          } else {
            setSnackMessage("Incorrect image dimension");
            setIsSnackError(true);
            setSnackOpen(true);
            setIsActive(false);
          }
        }, 2000);
      } else {
        setSnackMessage("File should be in .jpg / .jpeg / .png format");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      }
    } catch {
      setIsActive(false);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isActive) return;

    setIsActive(true);
    const errors = FormValidate(formData, required);
    if (Object.keys(errors).length === 0) {
      const form = new FormData();
      form.append("question", formData.question);
      form.append("answer", formData.answer);
      form.append("question_ma", formData.question_ma);
      form.append("answer_ma", formData.answer_ma);

      if (formData.question === '<p><br></p>') {
        setSnackMessage("Question in English is Required");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
        return;
      } else if (formData.question_ma === '<p><br></p>') {
        setSnackMessage("Question in Malayalam is Required");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
        return;
      } else if (formData.answer === '<p><br></p>') {
        setSnackMessage("Answer in English is Required");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
        return;
      } else if (formData.answer_ma === '<p><br></p>') {
        setSnackMessage("Answer in Malayalam is Required");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
        return;
      }      
      faq_add(form)
        .then((res) => {
          setSnackMessage(res.message);
          setIsSnackError(false);
          setSnackOpen(true);
          setIsActive(false);
        })
        .catch((error) => {
          setSnackMessage(error.message);
          setIsSnackError(true);
          setSnackOpen(true);
          setIsActive(false);
        });
    } else {
      setSnackMessage("Please fill all mandatory fields");
      setIsSnackError(true);
      setSnackOpen(true);
      setIsActive(false);
    }

  };


  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/faq-list");
    }
  };

  return (
    <div className="add-per">
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <Loader open={isActive} />
      <div className="view-container">
        <h6>
          <b>Add FAQ</b>
        </h6>
        <hr />
        <div className="row">
          <TextEditer
            label="Question[English]"
            value={formData?.question || undefined}
            name="question"
            id="question"
            required
            onChange={(value) => setFormData({ ...formData, question: value })}
          />
          <TextEditer
            label="Question[Malayalam]"
            value={formData?.question_ma || undefined}
            name="question_ma"
            id="question_ma"
            required
            onChange={(value) => setFormData({ ...formData, question_ma: value })}
          />


          <div className="col-12">
            <TextEditer
              label="Answer[English]"
              value={formData?.answer || undefined}
              name="answer"
              id="answer"
              required
              onChange={(value) => setFormData({ ...formData, answer: value })}
            />
            <TextEditer
              label="Answer[Malayalam]"
              value={formData?.answer_ma || undefined}
              name="answer_ma"
              id="answer_ma"
              required
              onChange={(value) => setFormData({ ...formData, answer_ma: value })}
            />

          </div>

          <div className="col-12">
            <center>
              <button
                type="button"
                className="btn btn-dark mt-3"
                onClick={(e) => handleSubmit(e)}
              >
                Submit for Acceptance
              </button>
            </center>
          </div>
          {/* ---------------- */}
        </div>
      </div>
    </div>
  );
}
